import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	categoriesGenericMessage: {
		id: 'servicedesk-knowledge-services.categories-generic-message',
		defaultMessage: "We couldn't create the category. Wait a moment, then try again.",
		description: 'Generic error message displayed when we failed to create a category.',
	},
	categoriesNoPermission: {
		id: 'servicedesk-knowledge-services.categories-no-permission',
		defaultMessage:
			"You'll need to be an agent to create a category. Ask an admin to check your permissions.",
		description:
			'The error shown when the user does not have permission to add categories to the project.',
	},
	categoriesLimitExceeded: {
		id: 'servicedesk-knowledge-services.categories-limit-exceeded',
		defaultMessage:
			'You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30.',
		description:
			'The error shown when the user has exceeded the maximum number of categories per project.',
	},
	categoriesNameFieldBlank: {
		id: 'servicedesk-knowledge-services.categories-name-field-blank',
		defaultMessage: 'Name cannot be blank',
		description:
			'The error shown when the user has not filled in the name field when creating a category.',
	},
	categoriesDescriptionFieldBlank: {
		id: 'servicedesk-knowledge-services.categories-description-field-blank',
		defaultMessage: 'Description cannot be blank',
		description:
			'The error shown when the user has not filled in the description field when creating a category.',
	},
	categoriesNameFieldTooLong: {
		id: 'servicedesk-knowledge-services.categories-name-field-too-long',
		defaultMessage: 'Name cannot be longer than 100 characters',
		description:
			'The error shown when the user has not filled in the name field when creating a category.',
	},
	categoriesDescriptionFieldTooLong: {
		id: 'servicedesk-knowledge-services.categories-description-field-too-long',
		defaultMessage: 'Description cannot be longer than 150 characters',
		description:
			'The error shown when the user has not filled in the description field when creating a category.',
	},
});
